import { ODataSelect } from "@iconics/core";
import { IStyling } from "../../../../Common/GraphStyleHelper";

export class Ontology extends ODataSelect
{
    public Name = "";
    public DisplayName = "";
    public Description = "";
    public IsEnabled = "";
    public Id = "";
    public ["@odata.etag"] = "";

    override toSelect(): string
    {
        return ''
    }
}

export interface IOntologyNodeData
{
    Name: string;
    IsEnabled: string;
    DisplayName: string;
    IsRequired: string;
    Id: string;
    IsRecursive: string;
    Parent_ID: string;
    Styling?: IStyling | null;
    ['@odata.etag']: string;
}
